﻿import * as Sentry from "@sentry/browser";

export interface AjaxOptions {
    BaseUrl?: string
    EndPoint: string;
    Type?: string;
    DataType?: string;
    ContentType?: string;
    Data?: any;
    Success?: JQuery.Ajax.SuccessCallback<any>;
    Fail?: JQuery.Ajax.SuccessCallback<any>;
    Error?: JQuery.Ajax.ErrorCallback<any>;
    DontShowError?: boolean;
    NoStringify?: boolean;
    Headers?: JQuery.PlainObject<string>;
    CorsEnable?: boolean;
    WithCredentials?: boolean;
}

export class Ajax {
    public Options: AjaxOptions

    constructor(options: AjaxOptions) {
        this.Options = options;
    }

    public Execute() {
        if (!this.Options.NoStringify) {
            this.Options.Data = JSON.stringify(this.Options.Data);
        }

        let ajaxSettings: JQuery.AjaxSettings = {
            url: (this.Options.BaseUrl || "") + this.Options.EndPoint,
            type: this.Options.Type || "POST",
            dataType: this.Options.DataType || "json",
            contentType: this.Options.ContentType || "application/json",
            data: this.Options.Data,
            cache: false,
            headers: this.Options.Headers || {},
            crossDomain: this.Options.CorsEnable || false,
            accepts: {
                json: "json"
            },
            error: (jqxhr: JQuery.jqXHR, errorTextStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) => {
                Sentry.addBreadcrumb({
                    category: "xhr",
                    level: "info",
                    data: {
                        url: (this.Options.BaseUrl || "") + this.Options.EndPoint,
                        data: this.Options.Data,
                        headers: this.Options.Headers,
                        jqxhr: jqxhr,
                        errorTextStatus: errorTextStatus,
                        errorThrown: errorThrown
                    }
                });
                if (this.Options.Error) {
                    this.Options.Error(jqxhr, errorTextStatus, errorThrown);
                }
            }
        }
        if (this.Options.WithCredentials) {
            ajaxSettings.xhrFields = {
                withCredentials: this.Options.WithCredentials
            }
        }
        return $.ajax(ajaxSettings);
    }

    public static Execute(options: AjaxOptions) {
        return new Ajax(options).Execute();
    }
}
